import React from 'react';
import { GoogleMap, LoadScript, Marker, InfoWindow } from '@react-google-maps/api';
import { COLLEGE } from '../constants';

const GoogleMapComponent = () => {
  const mapCenter = COLLEGE.COORDINATES;

  const mapContainerStyle = {
    width: '100%',
    height: '300px',
    borderRadius: '8px'
  };

  const mapOptions = {
    zoom: 15,
    center: mapCenter,
    mapTypeControl: true,
    streetViewControl: true,
    fullscreenControl: true,
  };

  const [showInfoWindow, setShowInfoWindow] = React.useState(false);
  const [mapError, setMapError] = React.useState(null);

  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

  // Handle map load errors (e.g., billing not enabled)
  const handleMapError = (error) => {
    console.error('Google Maps error:', error);
    if (error && error.message && error.message.includes('BillingNotEnabled')) {
      setMapError('billing');
    } else {
      setMapError('unknown');
    }
  };

  // Fallback to embed if API key is not configured
  // Using coordinates: 26.635833, 82.055389 (26°38'09.0"N, 82°03'19.4"E)
  if (!apiKey) {
    return (
      <div className="map-container">
        <iframe
          src={`https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3568.123456789!2d${COLLEGE.COORDINATES.lng}!3d${COLLEGE.COORDINATES.lat}!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2s${encodeURIComponent(COLLEGE.FULL_NAME)}%2C%20${encodeURIComponent(COLLEGE.STATE)}%20${COLLEGE.PIN}!5e0!3m2!1sen!2sin!4v1234567890123!5m2!1sen!2sin&q=${COLLEGE.COORDINATES.lat},${COLLEGE.COORDINATES.lng}`}
          width="100%"
          height="300"
          style={{ border: 0, borderRadius: '8px' }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="College Location"
        ></iframe>
      </div>
    );
  }

  // Show error message if billing is not enabled
  if (mapError === 'billing') {
    return (
      <div className="map-container">
        <div style={{ 
          padding: '20px', 
          textAlign: 'center', 
          backgroundColor: '#fff3cd', 
          borderRadius: '8px',
          border: '1px solid #ffc107'
        }}>
          <h6 style={{ color: '#856404', marginBottom: '10px' }}>
            ⚠️ Google Maps Billing Required
          </h6>
          <p style={{ color: '#856404', fontSize: '14px', marginBottom: '10px' }}>
            Please enable billing in Google Cloud Console to display the interactive map.
          </p>
          <p style={{ color: '#856404', fontSize: '12px' }}>
            <a 
              href="https://console.cloud.google.com/billing" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{ color: '#856404', textDecoration: 'underline' }}
            >
              Enable Billing →
            </a>
          </p>
        </div>
        {/* Fallback to embed map */}
        <iframe
          src={`https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3568.123456789!2d${COLLEGE.COORDINATES.lng}!3d${COLLEGE.COORDINATES.lat}!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2s${encodeURIComponent(COLLEGE.FULL_NAME)}%2C%20${encodeURIComponent(COLLEGE.STATE)}%20${COLLEGE.PIN}!5e0!3m2!1sen!2sin!4v1234567890123!5m2!1sen!2sin&q=${COLLEGE.COORDINATES.lat},${COLLEGE.COORDINATES.lng}`}
          width="100%"
          height="300"
          style={{ border: 0, borderRadius: '8px', marginTop: '10px' }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="College Location"
        ></iframe>
      </div>
    );
  }

  return (
    <div className="map-container">
      <LoadScript 
        googleMapsApiKey={apiKey}
        onError={handleMapError}
      >
        <GoogleMap
          mapContainerStyle={mapContainerStyle}
          options={mapOptions}
          onError={handleMapError}
        >
          {/* Note: Marker is deprecated but still functional. 
              AdvancedMarkerElement migration can be done later when library supports it. */}
          <Marker
            position={mapCenter}
            onClick={() => setShowInfoWindow(true)}
            title={COLLEGE.FULL_NAME}
          />
          {showInfoWindow && (
            <InfoWindow
              position={mapCenter}
              onCloseClick={() => setShowInfoWindow(false)}
            >
              <div>
                <h6 style={{ margin: '0 0 8px 0', fontWeight: 'bold' }}>
                  {COLLEGE.NAME}
                </h6>
                <p style={{ margin: '0 0 4px 0', fontSize: '14px' }}>
                  {COLLEGE.ADDRESS_LINE}
                </p>
                <p style={{ margin: '0', fontSize: '12px', color: '#666' }}>
                  {COLLEGE.STATE}, {COLLEGE.COUNTRY}
                </p>
                <p style={{ margin: '4px 0 0 0', fontSize: '12px', color: '#666' }}>
                  Coordinates: {COLLEGE.COORDINATES_DMS}
                </p>
              </div>
            </InfoWindow>
          )}
        </GoogleMap>
      </LoadScript>
    </div>
  );
};

export default GoogleMapComponent;

